import {
  Container,
  Split,
  SplitSection,
  Text,
  TextButton,
  useMedia,
} from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';

import { COMMENTS_BREAKPOINT } from 'constants/breakpoints';
import { removeLocalDeleted, restoreCreator } from 'creators/comments';
import { isReply } from 'utilities/comments';

const DeleteUndoPlaceholder = props => {
  const { commentOrReply } = props;
  const dispatch = useDispatch();

  const textContent =
    !isReply(commentOrReply) && commentOrReply.replies.length
      ? 'Deleted a comment thread.'
      : `Deleted a comment from ${commentOrReply.user_name}.`;

  const restoreClick = () => {
    dispatch(restoreCreator(commentOrReply));
  };

  const dismissClick = () => {
    dispatch(removeLocalDeleted(commentOrReply));
  };

  const componentSize = useMedia(
    [`(min-width: ${COMMENTS_BREAKPOINT}px)`],
    ['medium'],
    'small'
  );

  return (
    <Container
      paddingLeft="medium"
      paddingRight="medium"
      radius="medium"
      backgroundColor="backgroundSecondary"
      paddingTop={0.5}
      paddingBottom={0.5}
      maxWidth={72}
    >
      <Split justifyContent="space-between">
        <SplitSection minWidth="0px">
          <Container paddingRight={4}>
            <Text size={componentSize} hasEllipsis color="bodyDimmed">
              {textContent}
            </Text>
          </Container>
        </SplitSection>
        <SplitSection>
          <TextButton size={componentSize} onClick={restoreClick}>
            Undo
          </TextButton>
          <TextButton size={componentSize} onClick={dismissClick}>
            Dismiss
          </TextButton>
        </SplitSection>
      </Split>
    </Container>
  );
};

export default DeleteUndoPlaceholder;
